import React, {useState, useEffect, useRef, Ref, forwardRef, useImperativeHandle} from 'react';
import {useDispatch} from 'react-redux';
import {actionCreators} from '../../../store';

import {useTypedSelector} from '../../../hooks/useTypeSelector';

import ButtonLoader, {IButtonLoaderRef} from '../../../com/buttonLoader/ButtonLoader';

import {ForgotPasswordDto} from '../../../dtos';

import TextInput from '../../../com/textInput/TextInput';

import './ForgotPasswordForm.scss';
import {getVariableName, validEmailRegex} from '../../../helpers/utils';
import {ActionType} from '../../../store/actionTypes';
import {EmailSent, IEmailSentRef} from "../emailSent/EmailSent";
import {makeStyles} from "@mui/styles";
import {Box, Typography} from "@mui/material";

const useStyles = makeStyles(() => ({
    formWrapper: {
        width: "100%"
    },
}))

export interface IForgotPasswordFormRef {
    sendEmail: () => void
}

interface IForgotPasswordForm {
    onEmailSent: () => void,
    show: boolean,
    handleResendAnotherEmail: () => void;
    refEmail: Ref<IEmailSentRef>;
}


const ForgotPasswordForm = forwardRef((props: IForgotPasswordForm, ref: Ref<IForgotPasswordFormRef>) => {

    const dispatch = useDispatch();
    const classes = useStyles();
    // for testing
    //const [emailAddress, setEmailAddress] = useState('shomron.hazave@xcircular.com');
    const [emailAddress, setEmailAddress] = useState('');
    const [errors, setErrors] = useState({emailAddress: ''});
    const [sentEmail, setSentEmail] = useState<boolean>(false);
    const {data, error, loading, type} = useTypedSelector((state) => state.auth);

    const hooksNames: string[] = [getVariableName({emailAddress})];

    //
    let buttonLoaderRef = useRef<IButtonLoaderRef>(null);
    useImperativeHandle(ref, () => ({sendEmail}));

    //
    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isFormdValid()) {
            return;
        }

        sendEmail()
    }

    const sendEmail = () => {
        let forgotPasswordDto: ForgotPasswordDto = {
            emailAddress
        }

        buttonLoaderRef.current?.showLoader(true);

        dispatch(actionCreators.forgotPassword(forgotPasswordDto));
    }

    useEffect(() => {
        if (type === ActionType.FORGOT_PASSWORD_SUCCESS) {
            setTimeout(() => {
                props.onEmailSent();
                setSentEmail(true);
            }, delay);
        }
    })

    const isFormdValid = () => {

        let allErrors = validate();

        // if length === 0 => true
        // else false
        return Object.values(allErrors).join('').length === 0;
    }

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>, hookName: string, hookFunction: React.Dispatch<React.SetStateAction<any>>) => {
        var value = event.target.value;
        hookFunction(value);

        validate(hookName, value);
    }

    const validate = (hookName?: string, enforceValue?: any) => {

        let allErrors: any = {...errors}

        hooksNames.forEach(name => {
            let currentError = validateInput(name, enforceValue);

            if (hookName) {
                // validate only 1 input
                if (name === hookName) {
                    allErrors[name] = currentError;
                }
            } else {
                // validate all inputs
                allErrors[name] = currentError;
            }
        });

        setErrors(allErrors);

        return allErrors;
    }

    const validateInput = (name: string, enforceValue?: any) => {

        let value = null;
        let err = '';
        if (enforceValue === undefined) {
            switch (name) {

                case getVariableName({emailAddress}):
                    value = enforceValue ? enforceValue : emailAddress
                    err = !validEmailRegex.test(value)
                        ? 'Email address is wrong'
                        : ''
                    break;
            }
        }

        return err;
    }

    const delay = 500;

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                buttonLoaderRef.current?.showLoader(false);
            }, delay);
        }
    }, [loading])

    // if(!props.show){
    //     return null
    // }
    if (sentEmail) {
        return <EmailSent
            ref={props.refEmail}
            onResendAnotherEmailClick={props.handleResendAnotherEmail}
        />
    }

    return (
        <Box className={classes.formWrapper}>

            <Typography textAlign={"center"}
                        sx={{
                            fontSize: "28px",
                            textAlign: "center",
                            marginBottom: "32px",
                            fontWeight: 500
                        }}

            >
                Forgot password
            </Typography>

            <Typography textAlign={"center"}
                        sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            marginBottom: "18px",
                            fontWeight: 500
                        }}
            >
                Enter your email address and get an email with the link to reset the password
            </Typography>

            <form className="auth_item_container_form" onSubmit={onSubmit}>
                <div>
                    <TextInput
                        placeHolder="Work Email Address"
                        type="email"
                        value={emailAddress}
                        onChange={e => onInputChange(e, getVariableName({emailAddress}), setEmailAddress)}
                        errorMessage={errors.emailAddress}
                        isRequired={true}
                    />
                </div>

                <ButtonLoader ref={buttonLoaderRef}>
                    SEND
                </ButtonLoader>

                {/*<AuthPrivacy/>*/}
            </form>
        </Box>
    )
})

export default ForgotPasswordForm;
